module.exports = __webpack_public_path__ + "assets/block2.ba7510ef.png";